import { Routes } from "@angular/router";
/* -------------------- -- Routing components -- --------------------*/
import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";

export const AppRoutes: Routes = [
  // {path:'**', component:Page404Component},
  // {path: '', redirectTo:'page404', pathMatch:'full'}
  // {path: '', redirectTo: 'dashboard', redirectTo: 'dashboards', pathMatch: 'full',},

  { path: "", redirectTo: "pages/login", pathMatch: "prefix" },

  {
    path: "",
    component: AdminLayoutComponent,
    children: [
      {
        path: "",
        // loadChildren: './dashboard/dashboard.module#DashboardModule'
        loadChildren: "./dashboards/dashboards.module#DashboardsModule",
      },
      
      {
        path: "admin",
        loadChildren: "./Admin/admin.module#AdminModule",
      },
      {
        path: "components",
        loadChildren: "./components/components.module#ComponentsModule",
      },
      {
        path: "forms",
        loadChildren: "./forms/forms.module#Forms",
      },
      {
        path: "tables",
        loadChildren: "./tables/tables.module#TablesModule",
      },
      {
        path: "maps",
        loadChildren: "./maps/maps.module#MapsModule",
      },
      {
        path: "widgets",
        loadChildren: "./widgets/widgets.module#WidgetsModule",
      },
      {
        path: "charts",
        loadChildren: "./charts/charts.module#ChartsModule",
      },
      {
        path: "calendar",
        loadChildren: "./calendar/calendar.module#CalendarModule",
      },
      {
        path: "",
        loadChildren: "./userpage/user.module#UserModule",
      },
      {
        path: "",
        loadChildren: "./timeline/timeline.module#TimelineModule",
      },
    ],
  },

  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "pages",
        loadChildren: "./pages/pages.module#PagesModule",
      },
    ],
  },
];
